module.exports = __webpack_public_path__ + "img/1008.07da0645.png";